<template>
  <div class="more-tags">
    <h2 class="more-tags__headline">
      {{ headline }}
    </h2>

    <div class="more-tags__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    headline: {
      type: String,
    },
  },
};
</script>

<style  lang="scss">
@import "../scss/importall.scss";

.more-tags {
  padding: 4rem 0 1rem;
}

.more-tags__headline {
  @extend %text;

  margin: 0 0 2rem;
  color: var(--aside-text-color, #000);
}
</style>
